package gr.tech.site.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.role
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.navigation.OpenLinkStrategy
import com.varabyte.kobweb.silk.components.layout.HorizontalDivider
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.navigation.UncoloredLinkVariant
import com.varabyte.kobweb.silk.components.navigation.UndecoratedLinkVariant
import com.varabyte.kobweb.silk.style.toModifier
import gr.tech.site.styles.ButtonHoverDarkGreen
import gr.tech.site.styles.wideCappedWidth
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.Text

@Composable
fun NotFoundPage() {
    Column(
        modifier = Modifier
            .wideCappedWidth()
            .classNames("my-5", "mx-auto", "h-full"),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        H3(
            Modifier.classNames("fs-1", "w-full", "text-center")
                .toAttrs()
        ) {
            Text("Oops! That page can't be found!")
        }

        HorizontalDivider(modifier = Modifier.classNames("my-3"))

        Link(
            path = "/",
            text = "Back to Home",
            variant = UndecoratedLinkVariant.then(UncoloredLinkVariant),
            modifier = ButtonHoverDarkGreen.toModifier()
                .classNames("fs-5", "mt-3", "px-4", "py-3", "shadow")
                .role("button").attrsModifier {
                    attr("aria-label", "To Home Screen Button")
                },
            openInternalLinksStrategy = OpenLinkStrategy.IN_PLACE,
            openExternalLinksStrategy = OpenLinkStrategy.IN_PLACE
        )
    }
}